<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
          <div class="row mt-3">
            <div class="col-lg-12">
              <TextEditor
                  v-model="formData.targetControl"
                  @update:model-value="formData.targetControl = $event"
                  :inputStyle="{ height: '200px' }"
                  label="Zielkontrolle"/>
            </div>
            <div class="col-lg-12 mt-4">
              <TextEditor
                  v-model="formData.recommendedAction"
                  @update:model-value="formData.recommendedAction = $event"
                  :inputStyle="{ height: '200px' }"
                  label="Handlungsempfehlung"/>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-5">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalGroupCoachingService from '@/api/Portal/GroupCoaching';
import unemployedGroupCoachingService from '@/api/Unemployed/GroupCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import TextEditor from '@/components/TextEditor.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/GroupCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/GroupCoaching/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const { t }            = useI18n();
const route            = useRoute();
const coachingData     = ref('');
const isLoaded         = ref(false);
const isSubmitting     = ref(false);
const coachingId       = +route.params.id;

const formData = ref({
  coachingId: '',
  targetControl: '',
  recommendedAction: '',
});

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalGroupCoachingService.submitFinalInterview(formData.value);

    await getFinalInterviewData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getGroupCoachingData() {
  try {
    CloseToast();
    const { data } = await unemployedGroupCoachingService.getGroupCoaching(+coachingId);

    coachingData.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getFinalInterviewData() {
  try {
    const { data } = await portalGroupCoachingService.getFinalInterview(+coachingId);

    formData.value = { ...data.data };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getGroupCoachingData(),
    getFinalInterviewData(),
  ]);

  isLoaded.value = true;
});
</script>
<style scoped>

</style>